import { BrowserRouter, NavLink, Route, Routes, Navigate } from 'react-router-dom';
import { useDotBotsAuth } from '@dotbots-boutique/auth-sdk/react';
import { useEffect } from 'react';

import Dashboard from './pages/Dashboard';
import CampaignDetail from './pages/CampaignDetail';
import CostCalculator from './pages/CostCalculator';
import ContentGenerator from './pages/ContentGenerator';
import { hasPermission } from './permissions';
import { lang, t } from './lib/i18n';

document.documentElement.lang = lang;

export default function App() {
  return (
    <BrowserRouter>
      <ManagerShell />
    </BrowserRouter>
  );
}

function ManagerShell() {
  const { user } = useDotBotsAuth();

  useEffect(() => {
    document.title = 'ViralLoop';
  }, []);

  const canRead = hasPermission(user?.roles, 'campaigns.read');

  if (!canRead) {
    return (
      <main style={{ padding: '2rem' }}>
        <div className="error">{t('shell.noAccessRoles')}</div>
      </main>
    );
  }

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">Viral<span>Loop</span></div>
        <nav>
          <NavLink to="/" end>{t('nav.campaigns')}</NavLink>
          <NavLink to="/cost">{t('nav.costCalculator')}</NavLink>
          <NavLink to="/content">{t('nav.contentGenerator')}</NavLink>
        </nav>
        <div className="user">
          {user?.name ? <>{t('shell.loggedInAs')} <strong>{user.name}</strong></> : null}
          {user?.orgName ? <> · {user.orgName}</> : null}
        </div>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/campaigns/:campaignId" element={<CampaignDetail />} />
          <Route path="/cost" element={<CostCalculator />} />
          <Route path="/content" element={<ContentGenerator />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
